import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { viewProfile } = appStoreLenses

export default viewProfile
